import { render, staticRenderFns } from "./Estudante-lixeira.vue?vue&type=template&id=52309370&scoped=true&"
import script from "./Estudante-lixeira.vue?vue&type=script&lang=js&"
export * from "./Estudante-lixeira.vue?vue&type=script&lang=js&"
import style0 from "./Estudante-lixeira.vue?vue&type=style&index=0&id=52309370&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52309370",
  null
  
)

export default component.exports